import { CorrespondanceModel } from "./correspondance.model";

export class FaxModel{
    genesysToken: string;
    correspondance: CorrespondanceModel;
    addresses: string[] = null;
    contentType: string = null;
}